export const seriesTrendsChartsPDFTitles = {
  closureTrend: "Percent Changed",
  pushTrend: "PUSH",
  hprTrend: "HPR",
  bwatTrend: "BWAT"
};
